<template>
  <svg :width="width" :height="height" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.50062 11.4996C6.66728 12.4996 8.5 15 8.50062 15.9996C8.50133 17.1609 7.84217 18.8011 6.56513 20C5.5 21 4.50157 23.2295 4.50062 23.9996C4.5 24.5 3.50064 27.9996 10.5006 27.9996M10.5006 27.9996C10.1006 15.5993 15.334 12.8331 18.0006 13C18.0006 12.1665 18.0006 9.79962 18.0006 6.99962C18.0006 4.19962 20.6673 3.83296 22.0006 3.99962V6.49962C22.834 6.49962 24.7006 6.49962 25.5006 6.49962C26.5006 6.49962 28.5006 8.99962 28.5006 10.9996C28.5006 12.5996 26.5006 12.8333 25.5006 13C25.5006 16.1667 25.5006 23.5996 25.5006 25.9996C25.5006 27 24.1604 27.9996 23.0006 27.9996C22.6272 27.9996 22.1196 27.9996 21.5006 27.9996M10.5006 27.9996C14.9599 27.9996 19.081 27.9996 21.5006 27.9996M21.5006 27.9996C21.834 25.8331 21.1007 21.6 15.5006 22"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'CatIcon',
  props: {
    width: {
      type: Number,
      default: 33,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
